import React from 'react'
import classNames from 'classnames'
import {
  IconCircleCheckFilled,
  IconCircleMinus,
  IconDots,
  IconXboxXFilled,
} from '@tabler/icons-react'

import { Loader } from '@/components/loaders/Loader'
import { matchUpdateProgress } from '@/views/Playbooks/playbook.helpers'

export const PlaybookProgressIcon = ({ darkBg, progress }) => {
  switch (progress) {
    case matchUpdateProgress.INITIAL:
      return <IconDots className="extra-muted-text" />
    case matchUpdateProgress.IGNORE:
      return <IconCircleMinus className="extra-muted-text" stroke="2" />
    case matchUpdateProgress.IN_PROGRESS:
      return <Loader size="small" />
    case matchUpdateProgress.FAILED:
      return (
        <IconXboxXFilled
          className={classNames('status-critical', { 'playbook-progress-icon': darkBg })}
        />
      )
    case matchUpdateProgress.DONE:
      return (
        <IconCircleCheckFilled
          className={classNames('status-success', { 'playbook-progress-icon': darkBg })}
        />
      )
    default:
      return <IconDots />
  }
}
